import { createFileRoute, redirect } from '@tanstack/react-router'
import { SEARCH_PARAM_SITE_ID } from 'routes/(global_search_params)/-searchParams'
import { Route as NewRoute } from 'routes/scheduling/index'

export const Route = createFileRoute('/scheduling/(deprecated_routes)/$siteID')(
  {
    beforeLoad: ({ params }) => {
      const siteId = params.siteID

      throw redirect({
        to: NewRoute.to,
        search: (prev) => ({
          ...prev,
          [SEARCH_PARAM_SITE_ID]: siteId,
        }),
        replace: true,
      })
    },
  }
)
